module.exports = __webpack_public_path__ + "img/hutaomu8.ffbad621.jpg";